//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

// 定位按钮
import PositionBtn from "../../components/PositionBtn/PositionBtn";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { PositionBtn },
  data() {
    //这里存放数据
    return {
      hid: 41190, //全域的hid
      scenicses: null,
      scenicPoi: [], //景点
      curMarkers: [], //当前地图中的点位
      activeScenicPoiData: null, //点击景点的数据
      myAudioSrc: null, //音频地址
      playing: false, //景点弹窗中音频播放状态
      mapObj: null,
      leLayer: null,
      scenicLng: 121.352056, //景区经纬度
      scenicLat: 29.236773, //景区经纬度
      mapMinZoom: 10,
      mapMaxZoom: 15,
      scenicBound: [
        [121.418965, 29.285191],
        [121.418965, 29.181659],
        [121.221479, 29.181659],
        [121.221479, 29.285191],
      ],
      isLocation: false, //是否展示当前定位了
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //获取全域所有点位信息
    getScenics() {
      let that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!findScenics.action",
        params: {},
        isShowLoading: true,
        success: function (data) {
          console.log(data);
          // 处理poi点层级数组数据
          function getPoiList(Arr) {
            let zoomRange =
              parseInt(that.mapMaxZoom) - parseInt(that.mapMinZoom); //层级差
            for (let j = 0; j < zoomRange + 1; j++) {
              let arr = [];
              Arr.push(arr);
            }
          }
          getPoiList(that.scenicPoi);
          that.setPois(data.data.points, that.mapMinZoom, that.mapMaxZoom);
          that.addPoi();
          that.scenicses = data.data.scenicses;
          for (let i in that.scenicses) {
            // 展示默认点位
            let marker = new AMap.Marker({
              map: that.mapObj,
              position: new AMap.LngLat(
                that.scenicses[i].longitude,
                that.scenicses[i].latitude
              ),
              content:
                "<div class='scenic'><div class='scenic-out'><img class='iconall' id='scenic" +
                "' src='" +
                that.GLOBAL.DOMAIN_URL +
                that.scenicses[i].thumbImg +
                "'></div><span class='scenicName'>" +
                that.scenicses[i].name +
                "</span></div>",
              offset: new AMap.Pixel(-24, -48),
              extData: {
                hid: that.scenicses[i].id,
              },
            });
            AMap.event.addListener(marker, "click", function (e) {
              let extData = e.target.getExtData();
              that.$router.push({
                path: "/scenic",
                name: "scenic",
                query: { hid: extData.hid },
              });
            });
          }
        },
      });
    },
    // 处理poi点数据
    setPois(pointses, mapMin, mapMax) {
      let that = this;
      // debugger

      for (let i in pointses) {
        // 最大缩放层级
        let max_zoom = pointses[i].max_zoom;
        // 最小缩放层级
        let min_zoom = pointses[i].min_zoom;
        let poiZoomRange = mapMax - mapMin;
        // console.log(i)
        // 语音点
        let marker = that.creatMarker(pointses[i]);
        AMap.event.addListener(marker, "click", function (e) {
          console.log(e.target.getExtData());
          that.activeScenicPoiData = e.target.getExtData().poiData;
          // that.myAudioSrc=this.activeScenicPoiData.audio;
          // that.mapObj
          that.playing = false;
          if (e.target.getExtData().poiData.audio != null) {
            that.myAudioSrc =
              that.GLOBAL.DOMAIN_URL +
              e.target.getExtData().poiData.audio.split(".")[0] +
              ".mp3";
          } else {
            that.myAudioSrc = null;
          }

          if (that.myAudioSrc != null) {
            document.getElementById("myAudio").load();
          }
        });
        let min = min_zoom - mapMin;
        for (let z = 0; z < poiZoomRange + 1; z++) {
          if (z >= min) {
            that.scenicPoi[z].push(marker);
          }
        }
      }
    },
    // 生成各个类别的poi点
    creatMarker(point) {
      let that = this;
      let className;
      let offset = new AMap.Pixel(-16, -32);
      switch (Number(point.type)) {
        case 2:
          className = "talk";
          //  content =
          // "<div class='poi'><div class='talk iconall'></div><span class='poiName'>" +
          // point.chs_name +
          // "</span></div>";
          offset = new AMap.Pixel(-16, -16);
          break;
      }
      let thisPoi = new AMap.Marker({
        content:
          "<div class='poi'><div class='" +
          className +
          " iconall'></div><span class='poiName talk'>" +
          point.chs_name +
          "</span></div>",
        position: new AMap.LngLat(point.longitude, point.latitude),
        // icon: "./data/btns/marker.png",
        offset: offset,
        extData: {
          poiData: point,
        },
      });
      return thisPoi;
    },
    // 加载地图
    setMap() {
      let that = this;
      // 创建地图实例
      that.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({
          // 创建地图二维视口
          center: new AMap.LngLat(that.scenicLng, that.scenicLat),
          zoom: 13, //设置地图缩放级别
          rotation: 0, //设置地图旋转角度
        }),
        resizeEnable: true,
        zooms: [that.mapMinZoom, that.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn", //设置地图语言类型，默认：中文简体
      });
      // 景区电子围栏
      // for (let i in that.scenicData.polygons) {
      //   that.scenicBound.push([
      //     that.scenicData.polygons[i].longitude,
      //     that.scenicData.polygons[i].latitude
      //   ]);
      // }
      that.getScenics();

      // 瓦片加载
      that.leLayer = new AMap.TileLayer({
        // 图块取图地址,加了s=1就是下沙景区限制
        tileUrl:
          // "https://pingshun.worldmaipu.com/upload_resources/tile/" +
          // that.hid +
          // "/[z]/[x]_[y].png",
          "https://tiles.worldmaipu.com/global/" + 52980 + "/[z]/[x]_[y].png",
        zIndex: 2,
      });
      that.leLayer.setMap(that.mapObj);

      // 开始定位
      that.isLocation = true; //定位组件 定位事件
      that.mapObj.on("complete", function () {
        console.log("地图加载完毕");
      });

      // 监听地图缩放结束事件
      AMap.event.addListener(that.mapObj, "zoomend", function () {
        console.log("当前地图层级==" + that.mapObj.getZoom());
        that.addPoi();
      });

      // 监听地图点击事件
      AMap.event.addListener(that.mapObj, "click", function (e) {
        console.log("点击地图");
        console.log(e.lnglat);
      });
      // 加载插件
      // 缩放组件
      that.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(
          new AMap.ToolBar({
            position: "LB",
            //locate:true
            liteStyle: true,
            offset: new AMap.Pixel(10, 200),
          })
        );
      });
    },
    // 添加点位
    addPoi() {
      console.log("addPoi");
      this.mapObj.remove(this.curMarkers);
      // 语音点播放窗关闭 start
      // this.activeScenicPoiData = null;
      // if (!document.getElementById("myAudio").paused) {
      //   this.playing = false;
      //   this.myAudioSrc = null;
      //   document.getElementById("myAudio").pause();
      // }
      // 语音点播放窗关闭 end
      let zoom = this.mapObj.getZoom();
      // if (lanType == 1) {

      this.curMarkers = this.scenicPoi[zoom - this.mapMinZoom];

      this.mapObj.add(this.curMarkers);
    },

    // 播放景点的音频
    playScenicAudio() {
      let that = this;
      let audio = document.getElementById("myAudio");
      if (this.myAudioSrc == null) {
        this.$vux.toast.text("暂无音频", "bottom");
      } else {
        if (audio.paused) {
          audio.play();
          audio.addEventListener("ended", function () {
            that.playing = false;
          });
          this.playing = true;
        } else {
          audio.pause();
          this.playing = false;
        }
      }
    },
    nav(name, lat, lng) {
      this.commonFun.openLocation(
        name,
        sessionStorage.getItem("lat"),
        sessionStorage.getItem("lng"),
        lat,
        lng
      );
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.getScenics();
    this.setMap();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/Index/Index.vue